import { useState } from "react";

import { WebSocketProvider as IqfWebSocketProvider } from "iqf-web-ui/web-socket";

import { ENV } from "@/env";

export function WebSocketProvider({ children }: { children: React.ReactNode }) {
  const [connectHeaders, setConnectHeaders] = useState({});

  return (
    <IqfWebSocketProvider
      fullUrl={`${ENV.VITE_API_BASE_PATH}/stomp`}
      connectHeaders={connectHeaders}
      setConnectHeaders={setConnectHeaders}
      requiredAuthorization={true}
    >
      {children}
    </IqfWebSocketProvider>
  );
}
